<template>
    <form-row title="Attorney">
        <contact-selector
            name_prefix="attorney"
            :available_contacts="available_contacts"
            contact_type="buyer_attorney"
            :value="{
                contact_id: attorney.contact_id,
                name: attorney.attorney_name,
                email: attorney.attorney_email,
                phone: attorney.attorney_phone,
            }"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
import ContactSelector from '../../components/contact-selector.vue';

export default {
    components: {
        ContactSelector,
    },

    props: {
        attorney: {},
        available_contacts: { default: () => [] },
        read_only: { default: false },
    },
}
</script>
